import styled from "styled-components";

const NumberContainer = styled.div`

font-family: 'Dancing Script', cursive;
font-size: 24px;
color: white;

display:flex;
padding: 0 10px;


`

export default NumberContainer;